/* eslint-disable react/jsx-props-no-spreading */

import Select from '@khanacademy/react-multi-select';
import cx from 'classnames';
import { ErrorMessage } from 'formik';
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import useSortedOptions from '../../hooks/use-sorted-options';
import { removeMultiselectTabIndexes } from '../../routines/utils';

const MultiSelect = (props) => {
  const {
    name,
    label,
    value,
    onChange,
    required,
    showIcon,
    formInput,
    placeholder,
    wrapperClassName,
    disabled,
    options,
    sort,
    disabledPlaceholder,
    ...rest
  } = props;

  const listOptions = useSortedOptions(options, sort);

  useEffect(() => {
    removeMultiselectTabIndexes();
  }, []);

  return (
    <div
      className={cx(
        'multi-select-wrap',
        { 'no-icon': !showIcon },
        { 'dropdown-disabled': disabled },
        wrapperClassName,
      )}
    >
      {label && (
        <label htmlFor={name} className="label-heading">
          {label} <span className="input-mandatory">{required ? '*' : ''}</span>
        </label>
      )}
      <Select
        overrideStrings={{
          selectSomeItems: placeholder || 'Select',
          allItemsAreSelected: disabledPlaceholder || 'Overall',
          selectAll: 'Overall',
          search: 'Search',
          className: 'multi-select-dropdown',
        }}
        name={name}
        placeholder={placeholder}
        onSelectedChanged={onChange}
        selected={value}
        required={required}
        disabled={disabled}
        options={listOptions}
        {...rest}
      />
      {formInput && (
        <div className="error-msg">
          <ErrorMessage name={name} />
        </div>
      )}
    </div>
  );
};

MultiSelect.propTypes = {
  disabled: PropTypes.bool,
  name: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  required: PropTypes.bool,
  showIcon: PropTypes.bool,
  formInput: PropTypes.bool,
  placeholder: PropTypes.string,
  wrapperClassName: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.any),
  sort: PropTypes.bool,
  disabledPlaceholder: PropTypes.string,
};

MultiSelect.defaultProps = {
  name: '',
  label: '',
  value: '',
  onChange: () => {},
  required: false,
  showIcon: false,
  formInput: false,
  placeholder: 'Select',
  wrapperClassName: '',
  disabled: false,
  options: [],
  sort: false,
  disabledPlaceholder: '',
};

export default MultiSelect;
